import { Button, message } from "antd";
import { CloseIcon, SuccessIcon } from "../../CustomIcons";

const SuccessMessage = (text: string) => {
  const myMessage = () => {
    message.success({
      key: "success",
      type: "success",
      content: (
        <div className="toast_wrapper">
          <div className="toast_text">{text}</div>
          <Button
            onClick={() => message.destroy("success")}
            icon={<CloseIcon />}
            className="close_icon"
          />
        </div>
      ),
      icon: <SuccessIcon />,
    });
  };

  return myMessage();
};

export default SuccessMessage;
